var map = {
	"./1/camp_admin_event.jpg": 314,
	"./1/camp_home.jpg": 370,
	"./2/camp_admin_event.jpg": 364,
	"./2/camp_home.jpg": 54,
	"./data": 351,
	"./data.json": 351
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 428;